module.exports = __webpack_public_path__ + "img/apple.3a72dd87.svg";